export { BrandProvider, useBrand } from './brandProvider'

export const BrandOptions = {
  default: 'default' as const,
  legacy: 'legacy' as const,
}

export type IBrand = keyof typeof BrandOptions

export type IAvailableBrandOptions = {
  [key in IBrand]: object
}

export interface IProps {
  children?: React.ReactNode
  forcedBrand?: IBrand
}

export type ISwitchBrand = (brand: IBrand) => void
